<template lang="pug">
  //- mixin nav(logo, n, authorizations, lang)
  nav.nav
    .nav__wrap-menu
      Logo( :white="dark" )
      //-img(src="../../assets/images/ar.png" style="width: 40px")
      Menu( :white="dark" )
    AuthBlock(
      :show="authBlock"
      :dark="dark"
      small
    )

    .nav__lang
      Lang( :dark="dark" )
    //- if authorizations
    //-     include ../common/authorizations
    //-     +authorizations(authorizations)

    //- .nav__lang(class=n)
    //-     include ../common/lang.pug
    //-     +lang(class=lang)
</template>

<script>
import isHomePage from '../../mixins/isHomePage'

import Logo from './Logo'
import Menu from './Menu'
import AuthBlock from './AuthBlock'
import Lang from './Lang'

export default {
  mixins: [isHomePage],
  props: {
    dark: {
      type: Boolean,
      default: false
    },
    authBlock: {
      type: Boolean,
      default: true
    }
  },
  components: {
    Logo,
    Menu,
    AuthBlock,
    Lang
  }
}
</script>

<style lang="scss">
  .nav {
    box-sizing: border-box;
    position: relative;

    display: flex;
    justify-content: space-between;
    align-items: center;

    max-width: 1600px;
    width: 100%;

    margin: 0 auto;

    padding-top: 20px;
    padding-left: 30px;
    padding-right: 30px;
    padding-bottom: 8px;
    min-height: 63px;

    &__wrap-menu {
      display: flex;
      justify-content: space-between;
      flex-basis: 754px;
      @media(max-width: 1366px){
        flex-basis: 590px;
        justify-content: flex-start;
      }
    }

    &__lang {
      display: flex;
      // flex-basis: 154px;
      justify-content: flex-end;
      width: 50px;
      position: relative;
      top: -23px;

      &Header {
        top: -20px;
      }
    }

    // mod
    &_padding_8 {
      padding-top: 8px;
      padding-bottom: 8px;
      margin-top: 5px;
    }

    @media (max-width: 1024px) {
      display: none;
    }

  //  Для Нового года
    .menu__item{
      white-space: nowrap;
      @media(max-width: 1366px){
        margin-left: 20px;
      }
    }

  }
</style>
